/* eslint-disable */
import React, { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import { useSelector, useDispatch } from 'react-redux';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faAngleRight, faAngleLeft } from '@fortawesome/free-solid-svg-icons';

import api from 'api';
import history from 'routes/history';
import RequestMaterialsActions from '../../../store/modules/request-materials/actions';

import TitlePages from 'components/_base/TitlePages';
import SubHeader from 'components/SubHeader';
import Card from 'components/Card';
import { GET_LIST_MATERIAL } from 'services/Solicitacao';
import { GET_RASCUNHO } from 'services/Rascunho';

import './styles.scss';

const ContentSelectMaterials = () => {
  const dispatch = useDispatch();
  const params = useParams();

  const [graphicMaterials, setGraphicMaterials] = useState([]);
  const [digitalMaterials, setDigitalMaterials] = useState([]);
  const [folderMaterials, setFolderMaterials] = useState([]);

  const { customer } = useSelector((state) => state.requestMaterials);

  const redirectPage = () => {
    history.push('/entrega-de-materiais');
  };

  const returnToPage = () => {
    history.push('/escolha-o-cliente');
  };

  if (!customer.codigo) {
    (async () => {
      try {
        const data = await GET_RASCUNHO(params.rascunhoId);
        const action = RequestMaterialsActions.setCustomer(data.value.loja);
        dispatch(action);
      } catch (error) {
      }
    })();
  }

  useEffect(() => {
    (async () => {
      const data = await GET_LIST_MATERIAL();
      let graphics = [];
      let digital = [];
      let folders = [];

      // eslint-disable-next-line
      data.value.map((item) => {
        if (item.materialComunicacaoTipo.nome === 'MATERIAIS GRAFICOS')
          graphics.push(item);
        if (item.materialComunicacaoTipo.nome === 'MATERIAIS DIGITAIS')
          digital.push(item);
        if (item.materialComunicacaoTipo.nome === 'ENCARTES')
          folders.push(item);
      });
      setGraphicMaterials(graphics);
      setDigitalMaterials(digital);
      setFolderMaterials(folders);
    })();
  }, []);

  return (
    <div className="content content-column">
      <SubHeader title={customer} />
      <TitlePages title="Selecione os Materiais" />
      <div className="content-cards">
        <Card title="Encartes" items={folderMaterials} type="folders" />
        <Card
          title="Materiais Digitais"
          items={digitalMaterials}
          type="digitals"
        />
        <Card
          title="Materiais Gráficos (MPDV)"
          items={graphicMaterials}
          type="graphics"
        />
      </div>
      <div className="buttons-navigation">
        <button onClick={returnToPage} className="btn btn-primary">
          <span>
            <FontAwesomeIcon icon={faAngleLeft} />
          </span>
          <span>VOLTAR</span>
        </button>
        <button onClick={redirectPage} className="btn btn-primary">
          <span>AVANÇAR</span>
          <span>
            <FontAwesomeIcon icon={faAngleRight} />
          </span>
        </button>
      </div>
    </div>
  );
};

export default ContentSelectMaterials;
